var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "CheckboxView u-InputMarginView",
      class: [
        _vm.modes.map((m) => `CheckboxView--${m}`),
        { "u-ErrorView": _vm.hasError },
      ],
    },
    [
      _c("div", { staticClass: "CheckboxView-wrapper" }, [
        !!_vm.title
          ? _c(
              "label",
              {
                staticClass: "CheckboxViewLabel",
                attrs: { for: `CheckboxView-input-${_vm._uid}` },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue,
                      expression: "innerValue",
                    },
                  ],
                  staticClass: "CheckboxViewInput",
                  attrs: {
                    type: "checkbox",
                    id: `CheckboxView-input-${_vm._uid}`,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.innerValue)
                      ? _vm._i(_vm.innerValue, null) > -1
                      : _vm.innerValue,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.innerValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.innerValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.innerValue = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { class: this.value && "active" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }